import { createSlice, PayloadAction } from "@reduxjs/toolkit";
// chatbot 
interface Message {
  sender: "user" | "bot";
  text: string;
}

interface ChatAssistantState {
  messages: Message[];
}

const initialState: ChatAssistantState = {
  messages: [{ sender: "bot", text: "Xin chào. Tôi là trợ lý ảo, tôi có thể giúp gì cho bạn không?" }],
};

export const chatAssistantSlice = createSlice({
  name: "chatAssistant",
  initialState,
  reducers: {
    addMessageAssistant: (state, action: PayloadAction<Message>) => {
      state.messages.push(action.payload);
    },
    resetMessagesAssistant: (state) => {
      state.messages = initialState.messages;
    },
  },
});

export const { addMessageAssistant, resetMessagesAssistant } = chatAssistantSlice.actions;
export default chatAssistantSlice.reducer;